var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueAliplayer',{ref:"video",staticClass:"video",staticStyle:{"width":"100%"},attrs:{"preload":true,"autoplay":true,"playsinline":false,"source":_vm.sourceUrl,"skinLayout":_vm.skinLayout,"height":_vm.videoHeight,"video-height":_vm.videoHeight},on:{"canplaythrough":_vm.canplaythroughimp,"play":_vm.onStartPlay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }